import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { TceSummaryBySituationUseCaseInterface } from 'domain/usecases';

export class TceSummaryBySituation
  implements TceSummaryBySituationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<TceSummaryBySituationUseCaseInterface.Result>,
  ) {}

  async execute(
    params: TceSummaryBySituationUseCaseInterface.Params,
  ): Promise<TceSummaryBySituationUseCaseInterface.Result> {
    const { ...restParams } = params;

    const requestUrl = `${this.url}/tces-counts`;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, restParams),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
